module.exports = __webpack_public_path__ + "e573fe6521dc792b48690227394aa729.svg";